<template>
  <catalog-table
    :tableHeaders="crewHeaders"
    :tableData="crews"
    :tableFilters="crewFilters"
    :propsToSearch="crewSearchableProps"
    :actions="crewActions"
    :loading-content-props="loadingContentInfo"
    :pageSize="100"
    hidePageSize
    hideFooter
  >
    <template v-if="$can('add', 'Crew', 'crew')" slot="search-toolbar-actions">
      <md-button class="md-success" @click="addCrew">
        <span class="md-label">
          <md-icon class="material-icons">add</md-icon>
        </span>
        Agregar
      </md-button>
    </template>
  </catalog-table>
</template>

<script>
import catalogService from "@/services/catalog";
import { CatalogTable } from "@/components/";
import { Modal } from "@/components";
import { booleanToState } from "@/filters";
import CrewEdit from "./Edit";

const loadingContentInfo = {
  emptyIcon: "people",
  emptyLabel: "No hay cuadrillas.",
  emptyDescription: "Registre una cuadrilla utilizando el boton superior.",
};

export default {
  name: "Crews",

  components: {
    CatalogTable,
    Modal,
    CrewEdit,
  },

  data() {
    return {
      crews: [],
      editModal: false,
      currentCrew: {},
      editModalTitle: "Editar Cuadrilla",
      crewHeaders: {
        name: "Nombre",
        attendantName: "Residente de Vialidades",
      },
      crewFilters: {
        isActive: booleanToState,
      },
      crewSearchableProps: ["name"],
      crewActions: [
        {
          icon: "edit",
          // exe: this.editCustomer
          exe: (crew) => {
            this.$router.push({ path: `/cuadrillas/${crew.id}` });
          },
          showIf: () => this.$can("change", "Crew", "crew"),
        },
      ],
      loadingContentInfo,
    };
  },

  methods: {
    deleteCrew(c) {
      this.$confirmMessage(
        { text: `Esta seguro que desea borrar ${c.name}?` },
        () => {
          return catalogService
            .delete("crew", c)
            .catch(this.$fireErrorResponse);
        }
      );
    },

    addCrew() {
      this.$router.push({ path: `/cuadrillas/nuevo` });
    },
    consultElement(url) {
      catalogService
        .fetch(url)
        .then((crews) => (this.crews = crews))
        .catch(this.$fireErrorResponse);
    },
  },

  mounted() {
    this.consultElement("crew");
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Catalogs/Crews/index.vue